import { boolean, object, string } from "yup";

const defaultMessage = "This is a required field.";
const ifDontKnow = {
  is: "dontKnow",
  then: string().required(defaultMessage),
  otherwise: string(),
};

export const validationSchema = object().shape({
  email: string()
    .required(defaultMessage)
    .email("Please enter a valid email address (ex: johndoe@domain.com)."),
  firstName: string().required(defaultMessage),
  privacy: boolean().oneOf([true], defaultMessage),
  lastName: string().required(defaultMessage),
  country: string().required(defaultMessage),
  message: string().required(defaultMessage),
  typeOfEnquiry: string().required(defaultMessage),
  driveStyle: string().when("typeOfEnquiry", ifDontKnow),
  make: string().when("typeOfEnquiry", ifDontKnow),
  model: string().when("typeOfEnquiry", ifDontKnow),
  year: string().when("typeOfEnquiry", ifDontKnow),
  engine: string().when("typeOfEnquiry", ifDontKnow),
  extraFront: string().when("typeOfEnquiry", ifDontKnow),
  extraRear: string().when("typeOfEnquiry", ifDontKnow),
  part: string().when("typeOfEnquiry", {
    is: "know",
    then: string().required(defaultMessage),
    otherwise: string(),
  }),
});
